import { connect } from 'react-redux'
import AddToGroup from '../../../../add-to-group/add-to-group.container'
import { addPupilToGroup } from '../../../../../stores/pupils/pupils.actions'
import { getPupil } from '../../../../../stores/pupils/pupils.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getErrorInfo } from 'pobble-components/dist/utils'

const mapDispatchToProps = dispatch => ({
  getGroups: (state, id) => getPupil(state, id).groups.map(group => group.id),
  action: (id, groupId) =>
    dispatch(
      addPupilToGroup(id, {
        student_account_id: id,
        group_id: groupId
      })
    ).catch(e => getErrorInfo(e).ref !== 'e0029' && errorHandler(e))
})

export default connect(
  null,
  mapDispatchToProps
)(AddToGroup)
